//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'rb-faq-module',
  computed: {
    titleIsPresent() {
      return this.$slots['accordion_title']
    },
  },
}
